(self["webpackChunkjets_theme"] = self["webpackChunkjets_theme"] || []).push([[0],{

/***/ 366:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(162);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(160);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(115);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(118);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(187);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(367);
/* harmony import */ var core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(137);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_ends_with_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(92);
/* harmony import */ var core_js_modules_es_string_ends_with_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_ends_with_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(247);
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(223);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(96);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(77);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(170);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(91);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(67);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(345);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(350);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(135);
/* harmony import */ var _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(364);
/* harmony import */ var _assets_svg_icon_arrow_left_svg__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(369);
/* harmony import */ var _assets_svg_icon_afterpay_svg__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(370);
/* harmony import */ var _gift_with_purchase__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(158);
/* harmony import */ var _cart_item__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(371);
/* harmony import */ var _free_shipping_bar__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(384);
/* harmony import */ var _rewards_balance_RewardsBalance__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(386);
/* harmony import */ var _trust_indicators__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(387);
/* harmony import */ var _cart_upsells__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(390);
/* harmony import */ var _cart_edit_item_popup__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(393);
























function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }














var emptyCart = {
  item_count: 0,
  items: [],
  total_price: 0
};

var Cart = function Cart(_ref) {
  var rootUrl = _ref.rootUrl,
      freeShippingBarSettings = _ref.freeShippingBarSettings,
      giftWithPurchaseDetails = _ref.giftWithPurchaseDetails,
      isCartPage = _ref.isCartPage;
  var defaultCart = window.theme.cart ? window.theme.cart : emptyCart;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_23__.useState)(defaultCart),
      _useState2 = _slicedToArray(_useState, 2),
      cart = _useState2[0],
      setCart = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_23__.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_23__.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      editItem = _useState6[0],
      setEditItem = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_23__.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      editProduct = _useState8[0],
      setEditProduct = _useState8[1];

  var itemsCount = cart.item_count;
  var cartItems = cart.items;
  var total = cart.total_price;

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_23__.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      giftProducts = _useState10[0],
      setGiftProducts = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_23__.useState)([]),
      _useState12 = _slicedToArray(_useState11, 2),
      upsellProducts = _useState12[0],
      setUpsellProducts = _useState12[1];

  var upsellsEnabled = window.theme.cartUpsells ? window.theme.cartUpsells.enabled : false;

  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_23__.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      showShippingBar = _useState14[0],
      setShowShippingBar = _useState14[1];

  var getUpsellProducts = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(items) {
      var _items, cartItemsIdArray, maxProducts, mostExpensiveProduct, productId, searchspringStoreID, profileTag, recentProducts, shopperParameter, cartParameter, lastViewedParameter, SSurl, options, response, json, upsellsRecommendations;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _items = items ? items : cartItems;

              if (!(_items.length <= 0)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              cartItemsIdArray = _items.map(function (item) {
                return item.product_id;
              });
              maxProducts = 4;
              mostExpensiveProduct = _items.reduce(function (prev, current) {
                return prev.final_price > current.final_price ? prev : current;
              });
              productId = mostExpensiveProduct.id;
              searchspringStoreID = window.theme.searchspring.storeId;
              profileTag = window.theme.searchspring.cartRecsProfileTag;

              if (profileTag) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return");

            case 11:
              recentProducts = JSON.parse(localStorage.getItem('ss_recently_viewed_products')) || [];
              shopperParameter = window.theme.customerId === '' ? '' : "&shopper=".concat(window.theme.customerId);
              cartParameter = cartItemsIdArray.length ? "&cart=".concat(cartItemsIdArray) : '';
              lastViewedParameter = recentProducts.length ? "&lastViewed=".concat(recentProducts.slice(0, 10)) : '';
              SSurl = "https://".concat(searchspringStoreID, ".a.searchspring.io/boost/").concat(searchspringStoreID, "/recommend?product=").concat(productId, "&tags=").concat(profileTag).concat(shopperParameter).concat(cartParameter).concat(lastViewedParameter);
              options = {
                headers: {
                  'Content-Type': 'application/json'
                }
              };
              _context.prev = 17;
              _context.next = 20;
              return fetch(SSurl, options);

            case 20:
              response = _context.sent;
              _context.next = 23;
              return response.json();

            case 23:
              json = _context.sent;
              upsellsRecommendations = json[0].results.slice(0, maxProducts);
              setUpsellProducts(upsellsRecommendations);
              _context.next = 31;
              break;

            case 28:
              _context.prev = 28;
              _context.t0 = _context["catch"](17);
              window.console.error(_context.t0);

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[17, 28]]);
    }));

    return function getUpsellProducts(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getGiftcardProducts = function getGiftcardProducts(items) {
    var _items = items ? items : cartItems;

    if (_items.length <= 0) {
      return;
    }

    var hasGiftCardProductItem = _items.some(function (item) {
      return item.product_type === 'Gift Cards';
    });

    if (hasGiftCardProductItem && freeShippingBarSettings.enabled && cartItems.length > 1) {
      setShowShippingBar(true);
    } else if (!hasGiftCardProductItem && freeShippingBarSettings.enabled && cartItems.length > 0) {
      setShowShippingBar(true);
    } else {
      setShowShippingBar(false);
    }
  };

  var updateCart = function updateCart(newCart) {
    window.theme.cart = newCart;

    if (isCartPage) {
      window.dispatchEvent(new Event('cartPageUpdated'));
    } else {
      window.dispatchEvent(new Event('cartDrawerUpdated'));
    } // Remove loading class


    document.body.classList.remove('cart-loading');
    setCart(newCart);
    var counters = document.querySelectorAll('[data-items-count]');
    counters.forEach(function (counter) {
      counter.innerHTML = newCart.item_count;
      counter.setAttribute('data-items-count', newCart.item_count);
    });

    if (upsellsEnabled) {
      getUpsellProducts(newCart.items);
    }

    var cartToggle = document.querySelector('.header__btn--cart');

    if (cartToggle) {
      if (newCart.item_count > 0) {
        cartToggle.classList.add('icon-animate');
      } else {
        cartToggle.classList.remove('icon-animate');
      }
    }

    getGiftcardProducts(newCart.items);
  };

  var fetchCart = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var url, options, response, json;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              url = "".concat(rootUrl, "/cart.js");
              options = {
                headers: {
                  'Content-Type': 'application/json'
                }
              };
              _context2.prev = 2;
              _context2.next = 5;
              return fetch(url, options);

            case 5:
              response = _context2.sent;

              if (!(response.ok === false)) {
                _context2.next = 8;
                break;
              }

              throw new Error('Fetch cart response was not OK');

            case 8:
              _context2.next = 10;
              return response.json();

            case 10:
              json = _context2.sent;
              return _context2.abrupt("return", json);

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](2);
              window.console.error(_context2.t0);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 14]]);
    }));

    return function fetchCart() {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   *
   * @typedef {Object} Item
   * @property {number} id - The Shopify variant ID.
   * @property {number} quantity - The quantity to add of this variant.
   * @property {Object.<string, string>} [properties] - Optional line item properties.
   * @property {Object} [variant] - Optional variant.
   */

  /**
   *
   * @param {...Item} items - Array of {@link Item} objects to add to cart.
   */


  var addLineItems = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(items) {
      var data, url, options, response, errorResponse, cartContents;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // Add loading class
              document.body.classList.add('cart-loading');
              data = {
                items: [items].flat()
              };
              url = "".concat(rootUrl, "/cart/add.js");
              options = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
              };
              _context3.prev = 4;
              _context3.next = 7;
              return fetch(url, options);

            case 7:
              response = _context3.sent;

              if (!(response.ok === false)) {
                _context3.next = 13;
                break;
              }

              _context3.next = 11;
              return response.json();

            case 11:
              errorResponse = _context3.sent;
              setErrorMessage(errorResponse.description);

            case 13:
              _context3.next = 15;
              return fetchCart();

            case 15:
              cartContents = _context3.sent;
              updateCart(cartContents);
              _context3.next = 22;
              break;

            case 19:
              _context3.prev = 19;
              _context3.t0 = _context3["catch"](4);
              window.console.error(_context3.t0);

            case 22:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[4, 19]]);
    }));

    return function addLineItems(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var updateLineItems = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(updates) {
      var data, url, options, response, cartContents;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // Add loading class
              document.body.classList.add('cart-loading');
              data = {
                updates: updates
              };
              url = "".concat(rootUrl, "/cart/update.js");
              options = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
              };
              _context4.prev = 4;
              _context4.next = 7;
              return fetch(url, options);

            case 7:
              response = _context4.sent;

              if (!(response.ok === false)) {
                _context4.next = 10;
                break;
              }

              throw new Error('cart/update response was not OK');

            case 10:
              _context4.next = 12;
              return response.json();

            case 12:
              cartContents = _context4.sent;
              updateCart(cartContents);
              _context4.next = 19;
              break;

            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](4);
              window.console.error(_context4.t0);

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[4, 16]]);
    }));

    return function updateLineItems(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleCartToggle = function handleCartToggle(event) {
    if (event) {
      event.preventDefault();
    }

    if (isCartPage) return;

    if (document.body.classList.contains('cart-is-visible')) {
      document.body.classList.remove('cart-is-visible');
      var cartOpenButton = document.querySelector('.header__btn--cart');

      if (cartOpenButton) {
        cartOpenButton.focus();
      }
    } else {
      document.body.classList.add('cart-is-visible');
      var cartCloseButton = document.querySelector('.cart__close');

      if (cartCloseButton) {
        cartCloseButton.focus();
      }
    }
  };

  var addToCartTracking = function addToCartTracking(items) {
    [items].forEach(function (item) {
      var _learnq = window._learnq || [];

      var cartData = window.theme.cart;
      cartData.items.forEach(function (cartItem) {
        var allItemKeys = Object.keys(cartItem);
        allItemKeys.forEach(function (key) {
          if (!(key.endsWith('_price') || key === 'price')) return;
          var price = cartItem[key];
          if (price !== Math.floor(price)) return;
          cartItem[key] = (price / 100).toFixed(2);
        });
      });
      var klaviyoData = {
        item: item,
        cartData: cartData
      };

      _learnq.push(['track', 'Add to Cart', klaviyoData]);
    });
  };
  /**
   *
   * @param {...Item} items - Array of {@link Item} objects to add to cart.
   * @param {boolean} openCart - Triggers the cart to open when item added if true
   */


  var handleAddToCartEvent = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(items) {
      var _window$theme, _window$theme$routes;

      var openCart,
          callback,
          lineItems,
          _args5 = arguments;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              openCart = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : false;
              callback = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : null;

              // Items could contain extra data like properties or variant info.
              // This reassignment strips out all but id, qty and properties to pass
              // to the addLineItems function for the cart.
              if (openCart) {
                handleCartToggle();
              }

              if (window.location.pathname === ((_window$theme = window.theme) === null || _window$theme === void 0 ? void 0 : (_window$theme$routes = _window$theme.routes) === null || _window$theme$routes === void 0 ? void 0 : _window$theme$routes.cartUrl)) {
                window.scroll({
                  top: 0
                });
              }

              lineItems = [items].flat().map(function (item) {
                // ID and Qty will always be part of the array
                var newLineItem = {
                  id: item.id,
                  quantity: item.quantity
                }; // Only add properties if they exist

                if ('properties' in item) {
                  newLineItem.properties = item.properties;
                }

                return newLineItem;
              });
              _context5.prev = 5;
              _context5.next = 8;
              return addLineItems(lineItems);

            case 8:
              // Send Klaviyo tracking event
              addToCartTracking(items);

              if (callback && typeof callback === 'function') {
                callback();
              }

              _context5.next = 16;
              break;

            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](5);
              window.console.error(_context5.t0);
              throw _context5.t0;

            case 16:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[5, 12]]);
    }));

    return function handleAddToCartEvent(_x4) {
      return _ref6.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_23__.useEffect)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
    var url, options, response, json;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(giftProducts === null)) {
              _context6.next = 4;
              break;
            }

            setGiftProducts(giftWithPurchaseDetails);
            _context6.next = 21;
            break;

          case 4:
            url = '/cart?view=gift-with-purchase';
            options = {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            };
            _context6.prev = 6;
            _context6.next = 9;
            return fetch(url, options);

          case 9:
            response = _context6.sent;

            if (!(response.ok === false)) {
              _context6.next = 12;
              break;
            }

            throw new Error('gift with purchase response was not OK');

          case 12:
            _context6.next = 14;
            return response.json();

          case 14:
            json = _context6.sent;
            setGiftProducts(json);
            _context6.next = 21;
            break;

          case 18:
            _context6.prev = 18;
            _context6.t0 = _context6["catch"](6);
            window.console.error(_context6.t0);

          case 21:
            getGiftcardProducts(cartItems);

          case 22:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[6, 18]]);
  })), [cart]);
  (0,react__WEBPACK_IMPORTED_MODULE_23__.useEffect)(function () {
    if (giftProducts === null) {
      return;
    }

    (0,_gift_with_purchase__WEBPACK_IMPORTED_MODULE_29__.checkGifts)(giftProducts, addLineItems, updateLineItems);
  }, [giftProducts]);
  (0,react__WEBPACK_IMPORTED_MODULE_23__.useEffect)(function () {
    if (isCartPage) {
      window.addEventListener('cartDrawerUpdated', function () {
        return setCart(window.theme.cart);
      });
    } else {
      window.sideCart = {
        handleAddToCartEvent: handleAddToCartEvent
      };
      var cartToggles = document.querySelectorAll('[data-toggle-cart]');
      cartToggles.forEach(function (cartToggle) {
        return cartToggle.addEventListener('click', handleCartToggle);
      });

      if (upsellsEnabled) {
        getUpsellProducts();
      }

      window.addEventListener('cartPageUpdated', function () {
        return setCart(window.theme.cart);
      });
    }

    getGiftcardProducts(cartItems);
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement(react__WEBPACK_IMPORTED_MODULE_23__.default.Fragment, null, isCartPage ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "page-header"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("h1", {
    className: "h3"
  }, window.theme.strings.cartTitle)) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement(react__WEBPACK_IMPORTED_MODULE_23__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "cart__header"
  }, cartItems.length > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("h2", {
    className: "cart__title"
  }, window.theme.strings.sideCartTitle, ": ", itemsCount), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("button", {
    type: "button",
    className: "cart__close btn__icon",
    "aria-label": window.theme.strings.closeCart,
    "data-toggle-cart": true
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_26__
    }
  }))), showShippingBar && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement(_free_shipping_bar__WEBPACK_IMPORTED_MODULE_31__.default, {
    total: total,
    freeShippingBarSettings: freeShippingBarSettings
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement(_rewards_balance_RewardsBalance__WEBPACK_IMPORTED_MODULE_32__.default, null)), errorMessage && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "cart__error-message"
  }, errorMessage, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("button", {
    type: "button",
    className: "cart__dismiss-message",
    "aria-label": window.theme.strings.dismissErrorMessage,
    onClick: function onClick() {
      return setErrorMessage(null);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_26__
    }
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "cart__loading-animation"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "loader"
  })), cartItems.length > 0 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "cart__content-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "cart__content"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("ul", {
    className: "cart__cart-items-container list-none"
  }, cartItems.map(function (item) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement(_cart_item__WEBPACK_IMPORTED_MODULE_30__.default, {
      item: item,
      updateLineItems: updateLineItems,
      setEditItem: setEditItem,
      setEditProduct: setEditProduct,
      rootUrl: rootUrl,
      key: item.key
    });
  })), isCartPage && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement(_trust_indicators__WEBPACK_IMPORTED_MODULE_33__.default, {
    layout: "grid",
    isCartPage: isCartPage
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement(_cart_edit_item_popup__WEBPACK_IMPORTED_MODULE_35__.default, {
    editItem: editItem,
    setEditItem: setEditItem,
    editProduct: editProduct,
    setEditProduct: setEditProduct,
    addLineItems: addLineItems
  }), upsellsEnabled && !isCartPage && upsellProducts.length ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement(_cart_upsells__WEBPACK_IMPORTED_MODULE_34__.default, {
    className: total === 0 ? 'hide' : '',
    total: total,
    products: upsellProducts,
    addToCart: handleAddToCartEvent
  }) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "cart__footer"
  }, window.theme.rewards.enabled && cartItems.length > 0 && isCartPage && window.theme.cartRewards.rewardsBlurbHeader && window.theme.cartRewards.rewardsBlurb && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "cart__rewards-desc"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("h4", {
    className: "cart__subheading"
  }, window.theme.cartRewards.rewardsBlurbHeader), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: window.theme.cartRewards.rewardsBlurb
    }
  })), cartItems.length > 0 && window.theme.showShippingInCart && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement(react__WEBPACK_IMPORTED_MODULE_23__.default.Fragment, null, isCartPage && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("h4", {
    className: "cart__subheading"
  }, "Order Summary"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "cart__subtotals"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "cart__subtotal"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("span", null, window.theme.strings.subtotal), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("span", null, (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_25__.formatMoney)(total, window.theme.moneyFormat))), cart.total_discount && cart.total_discount !== 0 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "cart__subtotal"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: window.theme.strings.cartDiscounts
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("span", null, (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_25__.formatMoney)(cart.total_discount, window.theme.moneyFormat))) : null, showShippingBar && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "cart__subtotal"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("span", null, window.theme.strings.shipping), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("span", {
    className: "cart__subtotal-value"
  }, total < freeShippingBarSettings.thresholdOne ? (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_25__.formatMoney)(window.theme.shippingPrice * 100, window.theme.moneyFormat) : (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_25__.formatMoney)(0, window.theme.moneyFormat))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "cart__total"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("span", null, window.theme.strings.total), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("span", {
    className: "cart__total-value"
  }, total < freeShippingBarSettings.thresholdOne && showShippingBar ? (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_25__.formatMoney)(total + window.theme.shippingPrice * 100, window.theme.moneyFormat) : (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_25__.formatMoney)(total, window.theme.moneyFormat)))))), isCartPage && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "cart__options"
  }, window.theme.cartIncludeAfterpay && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("p", null, "Or 4 payments of ", (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_25__.formatMoney)(total / 4, window.theme.moneyFormat), " with", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_afterpay_svg__WEBPACK_IMPORTED_MODULE_28__
    }
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "cart__checkout"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("a", {
    href: "".concat(rootUrl, "/checkout"),
    className: "btn btn--block"
  }, isCartPage ? window.theme.strings.checkout : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement(react__WEBPACK_IMPORTED_MODULE_23__.default.Fragment, null, total < freeShippingBarSettings.thresholdOne && showShippingBar ? (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_25__.formatMoney)(total + window.theme.shippingPrice * 100, window.theme.moneyFormat) : (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_25__.formatMoney)(total, window.theme.moneyFormat), ' ', "\u2013 ", window.theme.strings.checkout)), !isCartPage && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("a", {
    href: "/cart",
    className: "btn__text"
  }, window.theme.strings.viewCart)), isCartPage && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    "class": "cart__end"
  }, window.theme.cartContinueShoppingLink && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("a", {
    href: window.theme.cartContinueShoppingLink,
    className: "btn__text btn__text--icon-left"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_arrow_left_svg__WEBPACK_IMPORTED_MODULE_27__
    }
  }), window.theme.strings.cartContinueShopping))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("div", {
    className: "cart__empty text-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("h4", {
    dangerouslySetInnerHTML: {
      __html: window.theme.strings.cartEmpty
    }
  }), window.theme.cartEmptyLinks.length && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("ul", {
    className: "cart__empty-links"
  }, window.theme.cartEmptyLinks.map(function (item) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("li", {
      key: item.url
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement("a", {
      className: "btn btn--secondary btn--block",
      href: item.url
    }, item.title));
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_23__.default.createElement(_trust_indicators__WEBPACK_IMPORTED_MODULE_33__.default, {
    layout: "slider",
    isCartPage: isCartPage
  })));
};

Cart.propTypes = {
  rootUrl: (prop_types__WEBPACK_IMPORTED_MODULE_24___default().string),
  freeShippingBarSettings: (prop_types__WEBPACK_IMPORTED_MODULE_24___default().object),
  giftWithPurchaseDetails: (prop_types__WEBPACK_IMPORTED_MODULE_24___default().object),
  isCartPage: (prop_types__WEBPACK_IMPORTED_MODULE_24___default().bool)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Cart);

/***/ }),

/***/ 394:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(149);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(162);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(223);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(170);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(115);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(345);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(350);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _utils_updateVariant__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(395);
/* harmony import */ var _assets_scripts_utils_product_options_arrows__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(259);
/* harmony import */ var _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(364);














function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }







var CartEditItemPopup = function CartEditItemPopup(_ref) {
  var editItem = _ref.editItem,
      setEditItem = _ref.setEditItem,
      editProduct = _ref.editProduct,
      setEditProduct = _ref.setEditProduct,
      addLineItems = _ref.addLineItems;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(editProduct === null || editProduct === void 0 ? void 0 : editProduct.variants),
      _useState2 = _slicedToArray(_useState, 2),
      variants = _useState2[0],
      setVariants = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(editProduct === null || editProduct === void 0 ? void 0 : editProduct.variants.find(function (variant) {
    return variant.id === (editItem === null || editItem === void 0 ? void 0 : editItem.variant_id);
  })),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedVariant = _useState4[0],
      setSelectedVariant = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function () {
    setVariants(editProduct === null || editProduct === void 0 ? void 0 : editProduct.variants);
    setSelectedVariant(editProduct === null || editProduct === void 0 ? void 0 : editProduct.variants.find(function (variant) {
      return variant.id === (editItem === null || editItem === void 0 ? void 0 : editItem.variant_id);
    }));
  }, [editProduct, editItem]);
  (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function () {
    var productOptionsWrapper = document.querySelector('.cart-item__product-options');

    if (productOptionsWrapper) {
      (0,_assets_scripts_utils_product_options_arrows__WEBPACK_IMPORTED_MODULE_16__.default)(productOptionsWrapper);
    }
  }, [variants]);
  if (!editItem || !editProduct || !variants || !selectedVariant) return null;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.default.createElement(react__WEBPACK_IMPORTED_MODULE_13__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.default.createElement("div", {
    className: "fader fader--cart-item-variants",
    "aria-hidden": variants.length === 0,
    onClick: function onClick() {
      setEditItem(null);
      setEditProduct(null);
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.default.createElement("div", {
    className: "cart-item__variants-form",
    "aria-hidden": variants.length === 0
  }, variants.length > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.default.createElement(react__WEBPACK_IMPORTED_MODULE_13__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.default.createElement("div", {
    className: "cart-item__variants-form-header modal__header"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.default.createElement("h5", null, window.theme.strings.editSize), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.default.createElement("button", {
    type: "button",
    className: "btn__icon modal__close-button",
    onClick: function onClick() {
      setEditItem(null);
      setEditProduct(null);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_17__
    }
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.default.createElement("div", {
    className: "cart-item__variants-form-content"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.default.createElement("div", {
    className: "cart-item__product-options-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.default.createElement("div", {
    className: "cart-item__product-options"
  }, variants.map(function (variant) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.default.createElement("div", {
      className: "cart-item__product-option",
      key: variant.id
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.default.createElement("input", {
      type: "radio",
      id: variant.id,
      name: "size-option",
      onChange: function onChange() {
        return setSelectedVariant(variant);
      },
      checked: variant.id === selectedVariant.id,
      disabled: !variant.available,
      className: !variant.available && 'disabled'
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.default.createElement("label", {
      htmlFor: variant.id
    }, variant.title));
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.default.createElement("button", {
    type: "button",
    className: "btn btn--secondary btn--block",
    onClick: function onClick() {
      return (0,_utils_updateVariant__WEBPACK_IMPORTED_MODULE_15__.default)(editItem, selectedVariant, setVariants, setSelectedVariant, addLineItems);
    },
    disabled: editItem.variant_id === selectedVariant.id
  }, editItem.variant_id === selectedVariant.id ? window.theme.strings.selectSize : window.theme.strings.update)))));
};

CartEditItemPopup.propTypes = {
  editItem: (prop_types__WEBPACK_IMPORTED_MODULE_14___default().object),
  editProduct: (prop_types__WEBPACK_IMPORTED_MODULE_14___default().object),
  setEditItem: (prop_types__WEBPACK_IMPORTED_MODULE_14___default().func),
  setEditProduct: (prop_types__WEBPACK_IMPORTED_MODULE_14___default().func),
  addLineItems: (prop_types__WEBPACK_IMPORTED_MODULE_14___default().func)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CartEditItemPopup);

/***/ }),

/***/ 393:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _CartEditItemPopup__WEBPACK_IMPORTED_MODULE_0__.default)
/* harmony export */ });
/* harmony import */ var _CartEditItemPopup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(394);


/***/ }),

/***/ 372:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(100);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(162);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(338);
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(373);
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(374);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(170);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(223);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(115);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(91);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(143);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(345);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(350);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(135);
/* harmony import */ var _utils_changeLineItem__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(379);
/* harmony import */ var _assets_scripts_utils_shopify_images__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(380);
/* harmony import */ var _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(364);
/* harmony import */ var _assets_svg_icon_minus_sm_svg__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(381);
/* harmony import */ var _assets_svg_icon_plus_sm_svg__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(382);
/* harmony import */ var _assets_svg_icon_edit_svg__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(383);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





























var CartItem = function CartItem(_ref) {
  var _item$properties, _item$properties2, _item$featured_image;

  var item = _ref.item,
      updateLineItems = _ref.updateLineItems,
      setEditItem = _ref.setEditItem,
      setEditProduct = _ref.setEditProduct,
      rootUrl = _ref.rootUrl;
  var isGiftProduct = Boolean((_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : _item$properties._gwp);
  var comparePrice = Number((_item$properties2 = item.properties) === null || _item$properties2 === void 0 ? void 0 : _item$properties2._compare_price);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("li", {
    className: "cart-item"
  }, (item === null || item === void 0 ? void 0 : (_item$featured_image = item.featured_image) === null || _item$featured_image === void 0 ? void 0 : _item$featured_image.url) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("div", {
    className: "cart-item__image"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("a", {
    href: item.url
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("img", {
    src: item.featured_image.url,
    width: 106,
    height: 147,
    alt: item.title,
    loading: "lazy"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("div", {
    className: "cart-item__content"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("div", {
    className: "cart-item__content-group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("p", {
    className: "cart-item__title"
  }, item.product_title), comparePrice && comparePrice > item.price ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("p", {
    className: "cart-item__price"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("s", null, (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_20__.formatMoney)(comparePrice * item.quantity, window.theme.moneyFormat)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("span", {
    className: "cart-item__discounted-price"
  }, (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_20__.formatMoney)(item.line_price, window.theme.moneyFormat))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("p", {
    className: "cart-item__price"
  }, (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_20__.formatMoney)(item.line_price, window.theme.moneyFormat)), item.discounts && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("div", {
    className: "cart-item__discounts"
  }, item.discounts.map(function (discount) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("p", {
      key: discount.title
    }, discount.title);
  })), item.variant_title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("p", {
    className: "cart-item__variant"
  }, item.variant_title, !isGiftProduct && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("button", {
    type: "button",
    className: "btn__text",
    onClick: function onClick() {
      return (0,_utils_changeLineItem__WEBPACK_IMPORTED_MODULE_21__.default)(item, rootUrl, setEditItem, setEditProduct);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_edit_svg__WEBPACK_IMPORTED_MODULE_26__
    }
  }), window.theme.strings.edit)), item.properties && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("div", {
    className: "cart-item__properties"
  }, Object.entries(item.properties).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
        key = _ref3[0];

    return !key.startsWith('_');
  }).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        value = _ref5[1];

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("p", {
      key: key
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("span", {
      className: "cart-item__property-key"
    }, key), ": ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("span", null, value));
  }))), item.line_price > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("div", {
    className: "cart-item__quantity-selector quantity-selector"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("button", {
    onClick: function onClick() {
      return updateLineItems(_defineProperty({}, item.key, item.quantity - 1));
    },
    className: "btn__icon quantity-selector__btn is-minus",
    type: "button"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_minus_sm_svg__WEBPACK_IMPORTED_MODULE_24__
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("input", {
    id: "cart-qty_".concat(item.key),
    className: "quantity-selector__input",
    type: "number",
    name: "quantity",
    min: "1",
    "aria-label": window.theme.strings.itemQuantity,
    value: item.quantity,
    autoComplete: "off",
    onBlur: function onBlur(event) {
      return item.quantity === Number(event.target.value) ? null : updateLineItems(_defineProperty({}, item.key, event.target.value));
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("button", {
    onClick: function onClick() {
      return updateLineItems(_defineProperty({}, item.key, item.quantity + 1));
    },
    className: "btn__icon quantity-selector__btn is-plus",
    type: "button"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_plus_sm_svg__WEBPACK_IMPORTED_MODULE_25__
    }
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("div", {
    className: "cart-item__remove"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("button", {
    className: "btn__icon-minor",
    onClick: function onClick() {
      if (isGiftProduct) {
        var manuallyRemovedGifts = JSON.parse(sessionStorage.getItem('manuallyRemovedGifts')) || [];
        manuallyRemovedGifts.push(item.product_id);
        sessionStorage.setItem('manuallyRemovedGifts', JSON.stringify(Array.from(new Set(manuallyRemovedGifts))));
      }

      updateLineItems(_defineProperty({}, item.key, 0));
    },
    type: "button"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_23__
    }
  })))));
};

CartItem.propTypes = {
  item: (prop_types__WEBPACK_IMPORTED_MODULE_19___default().object),
  updateLineItems: (prop_types__WEBPACK_IMPORTED_MODULE_19___default().func),
  rootUrl: (prop_types__WEBPACK_IMPORTED_MODULE_19___default().string),
  setEditItem: (prop_types__WEBPACK_IMPORTED_MODULE_19___default().func),
  setEditProduct: (prop_types__WEBPACK_IMPORTED_MODULE_19___default().func)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CartItem);

/***/ }),

/***/ 371:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _CartItem__WEBPACK_IMPORTED_MODULE_0__.default)
/* harmony export */ });
/* harmony import */ var _CartItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(372);


/***/ }),

/***/ 391:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(104);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(134);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(307);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(147);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(148);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(110);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(162);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(149);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(223);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(77);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(170);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(115);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(67);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(118);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(3);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(345);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(350);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(135);
/* harmony import */ var react_flickity_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(389);
/* harmony import */ var react_flickity_component__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(react_flickity_component__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _shopify_theme_images__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(392);
/* harmony import */ var _assets_scripts_utils_product_options_arrows__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(259);
/* harmony import */ var _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(364);
/* harmony import */ var _assets_svg_icon_plus_sm_svg__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(382);
/* harmony import */ var _assets_svg_icon_minus_sm_svg__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(381);























function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }










/* eslint-disable babel/camelcase */

var CartUpsells = function CartUpsells(_ref) {
  var total = _ref.total,
      products = _ref.products,
      addToCart = _ref.addToCart;
  var upsellsHeading = window.theme.cartUpsells ? window.theme.cartUpsells.heading : '';
  var upsellsAddToCart = window.theme.cartUpsells.addToBag ? window.theme.cartUpsells.addToBag : 'Add';

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_22__.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      upsellsExpanded = _useState2[0],
      setUpsellsExpanded = _useState2[1];

  var upsellsCollapseWrapper = (0,react__WEBPACK_IMPORTED_MODULE_22__.useRef)(null);

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_22__.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedUpsell = _useState4[0],
      setSelectedUpsell = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_22__.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedVariant = _useState6[0],
      setSelectedVariant = _useState6[1];

  (0,react__WEBPACK_IMPORTED_MODULE_22__.useEffect)(function () {
    var productOptionsWrapper = document.querySelector('.cart-item__product-options');

    if (productOptionsWrapper) {
      (0,_assets_scripts_utils_product_options_arrows__WEBPACK_IMPORTED_MODULE_27__.default)(productOptionsWrapper);
    }
  }, [selectedUpsell]);

  var addUpsellProductToCart = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(variantId) {
      var item;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (variantId) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              item = {
                id: variantId,
                quantity: 1,
                properties: {
                  _cart_upsell: true
                }
              };
              _context.next = 5;
              return addToCart(item, false);

            case 5:
              setSelectedUpsell(null);
              setSelectedVariant(null);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function addUpsellProductToCart(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleUpsellToggle = function handleUpsellToggle(event) {
    if (event) {
      event.preventDefault();
    }

    if (upsellsCollapseWrapper.current) {
      if (upsellsExpanded) {
        upsellsCollapseWrapper.current.style.height = 0;
      } else {
        upsellsCollapseWrapper.current.style.height = "".concat(upsellsCollapseWrapper.current.scrollHeight, "px");
      }
    }

    setUpsellsExpanded(!upsellsExpanded);
  };

  var transformSSImageURL = function transformSSImageURL(imageURL) {
    var match = imageURL.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = imageURL.split(match[0]);
      var suffix = match[0];
      var prefixSplit = prefix[0].split('_');
      var lastSplit = prefixSplit[prefixSplit.length - 1];
      var prefixWithoutSize = lastSplit.includes('x') ? prefix[0].replace("_".concat(lastSplit), '') : prefix[0];
      return "".concat(prefixWithoutSize).concat(suffix);
    } else {
      return imageURL;
    }
  };

  var flickityOptions = {
    freeScroll: false,
    imagesLoaded: true,
    setGallerySize: true,
    watchCSS: true,
    prevNextButtons: false,
    pageDots: true,
    contain: true,
    groupCells: true,
    cellAlign: 'left'
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement(react__WEBPACK_IMPORTED_MODULE_22__.default.Fragment, null, total > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement(react__WEBPACK_IMPORTED_MODULE_22__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("div", {
    className: "cart__upsells ".concat(upsellsExpanded ? 'is-expanded' : '')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("button", {
    type: "button",
    className: "cart__upsell-toggle",
    onClick: handleUpsellToggle
  }, upsellsHeading, upsellsExpanded ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_minus_sm_svg__WEBPACK_IMPORTED_MODULE_30__
    }
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_plus_sm_svg__WEBPACK_IMPORTED_MODULE_29__
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("div", {
    className: "cart__upsell-items-wrapper",
    ref: upsellsCollapseWrapper
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement((react_flickity_component__WEBPACK_IMPORTED_MODULE_25___default()), {
    className: "cart__upsell-items",
    elementType: "div",
    options: flickityOptions,
    disableImagesLoaded: false,
    reloadOnUpdate: true,
    "static": true
  }, products.map(function (product) {
    var variants = JSON.parse(product.attributes.variants);
    var title = product.mappings.core.name;
    var featured_image = transformSSImageURL(product.attributes.ss_images[0]);
    var price = product.mappings.core.price * 100;
    var compare_at_price = product.attributes.variant_compare_at_price;
    var id = product.id;
    var handle = product.attributes.handle;
    product.variants = variants;
    var firstAvailableVariant = variants.find(function (variant) {
      return variant.inventory_quantity > 0;
    });
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("div", {
      key: id,
      className: "cart__upsell-item"
    }, featured_image && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("a", {
      href: "/products/".concat(handle),
      className: "cart__upsell-image--wrapper"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("div", {
      className: "cart__upsell-image"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("img", {
      src: (0,_shopify_theme_images__WEBPACK_IMPORTED_MODULE_26__.getSizedImageUrl)(featured_image, '212x294_crop_center'),
      width: 106,
      height: 147,
      alt: title
    }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("div", {
      className: "cart__upsell-info"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("div", {
      className: "cart__upsell-info--title"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("p", {
      className: "cart__upsell-title"
    }, title), compare_at_price > price ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("p", {
      className: "cart__upsell-price"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("s", null, (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_24__.formatMoney)(compare_at_price, window.theme.moneyFormat)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("span", {
      className: "cart__upsell-price--sale"
    }, (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_24__.formatMoney)(price, window.theme.moneyFormat))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("p", {
      className: "cart__upsell-price"
    }, (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_24__.formatMoney)(price, window.theme.moneyFormat))), variants && variants.length > 1 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("button", {
      type: "button",
      className: "btn btn--secondary btn--small",
      onClick: function onClick() {
        return setSelectedUpsell(product);
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: upsellsAddToCart
      }
    })) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("button", {
      type: "button",
      className: "btn btn--secondary btn--small",
      onClick: function onClick() {
        return addUpsellProductToCart(firstAvailableVariant === null || firstAvailableVariant === void 0 ? void 0 : firstAvailableVariant.id);
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: upsellsAddToCart
      }
    }))));
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("div", {
    className: "fader fader--cart-item-variants",
    "aria-hidden": !selectedUpsell,
    onClick: function onClick() {
      setSelectedUpsell(null);
      setSelectedVariant(null);
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("div", {
    className: "cart-item__variants-form",
    "aria-hidden": !selectedUpsell
  }, selectedUpsell && selectedUpsell.variants.length > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement(react__WEBPACK_IMPORTED_MODULE_22__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("div", {
    className: "cart-item__variants-form-header modal__header"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("h5", null, window.theme.strings.selectSize), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("button", {
    type: "button",
    className: "btn__icon modal__close-button",
    onClick: function onClick() {
      setSelectedUpsell(null);
      setSelectedVariant(null);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_28__
    }
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("div", {
    className: "cart-item__variants-form-content"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("div", {
    className: "cart-item__product-options-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("div", {
    className: "cart-item__product-options"
  }, selectedUpsell.variants.map(function (variant) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("div", {
      className: "cart-item__product-option",
      key: variant.id
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("input", {
      type: "radio",
      name: selectedUpsell.id,
      id: variant.id,
      onChange: function onChange() {
        return setSelectedVariant(variant);
      },
      disabled: variant.inventory_quantity <= 0,
      className: variant.inventory_quantity <= 0 && 'disabled'
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("label", {
      htmlFor: variant.id
    }, variant.title));
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_22__.default.createElement("button", {
    type: "button",
    className: "btn btn--block",
    onClick: function onClick() {
      return addUpsellProductToCart(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id);
    },
    disabled: !selectedVariant
  }, selectedVariant ? window.theme.strings.addToCart : window.theme.strings.selectSize))))));
};
/* eslint-enable babel/camelcase */

/* eslint-disable react/forbid-prop-types */


CartUpsells.propTypes = {
  total: (prop_types__WEBPACK_IMPORTED_MODULE_23___default().number),
  products: (prop_types__WEBPACK_IMPORTED_MODULE_23___default().array),
  addToCart: (prop_types__WEBPACK_IMPORTED_MODULE_23___default().func)
};
/* eslint-enable react/forbid-prop-types */

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CartUpsells);

/***/ }),

/***/ 390:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _CartUpsells__WEBPACK_IMPORTED_MODULE_0__.default)
/* harmony export */ });
/* harmony import */ var _CartUpsells__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(391);


/***/ }),

/***/ 385:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(104);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(110);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(345);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(350);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(135);






var FreeShippingBar = function FreeShippingBar(_ref) {
  var total = _ref.total,
      freeShippingBarSettings = _ref.freeShippingBarSettings;
  var remainingTemplate = freeShippingBarSettings.remainingTemplate,
      reachedTemplate = freeShippingBarSettings.reachedTemplate,
      serviceOne = freeShippingBarSettings.serviceOne,
      thresholdOne = freeShippingBarSettings.thresholdOne;
  /**
   * Create the free shipping remaining spend message.
   * @param {number} cartTotal
   * @param {number} threshold
   * @param {string} service
   * @returns {string}
   */

  var createRemainingMessage = function createRemainingMessage(cartTotal, threshold, service) {
    var remainingAmt = (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney)(threshold - cartTotal, window.theme.moneyFormat);
    return remainingTemplate.replace('{{ amount }}', remainingAmt).replace('{{ service }}', service);
  };
  /**
   * Construct free shipping bar percentage and message.
   *
   * @return {{percentage:Number, message:String}}
   */


  var calcFreeShippingStatus = function calcFreeShippingStatus() {
    if (total < thresholdOne) {
      return {
        barPercentage: total / thresholdOne * 100,
        barMessage: createRemainingMessage(total, thresholdOne, serviceOne)
      };
    } else {
      var service = serviceOne;
      return {
        barPercentage: 100,
        barMessage: reachedTemplate.replace('{{ service }}', service)
      };
    }
  };

  var _calcFreeShippingStat = calcFreeShippingStatus(),
      barPercentage = _calcFreeShippingStat.barPercentage,
      barMessage = _calcFreeShippingStat.barMessage;

  var barWidth = {
    width: "".concat(barPercentage, "%")
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("div", {
    className: "cart__free-shipping"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("div", {
    className: "cart__progress"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("div", {
    className: "cart__progress-bar",
    style: barWidth
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("p", null, barMessage));
};

FreeShippingBar.propTypes = {
  total: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
  freeShippingBarSettings: prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape({
    enabled: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool.isRequired),
    remainingTemplate: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
    reachedTemplate: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
    serviceOne: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
    thresholdOne: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired)
  })
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FreeShippingBar);

/***/ }),

/***/ 384:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _FreeShippingBar__WEBPACK_IMPORTED_MODULE_0__.default)
/* harmony export */ });
/* harmony import */ var _FreeShippingBar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(385);


/***/ }),

/***/ 158:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "checkGifts": () => (/* binding */ checkGifts)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_every_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(159);
/* harmony import */ var core_js_modules_es_array_every_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(160);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(147);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(148);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(162);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_5__);






var checkGifts = function checkGifts(giftDetails, addLineItems, updateLineItems) {
  if (!giftDetails) return;
  var gifts = giftDetails.gifts,
      giftsInCart = giftDetails.giftsInCart;
  var qualifyingGifts = gifts.filter(function (gift) {
    return gift.qualifies;
  });
  var manuallyRemovedGifts = JSON.parse(sessionStorage.getItem('manuallyRemovedGifts')) || [];
  /**
   * Remove any gifts that are invalid
   */

  var invalidGiftsInCart = giftsInCart.filter(function (giftInCart) {
    var doesNotQualify = qualifyingGifts.every(function (qualifyingGift) {
      return qualifyingGift.product.id !== giftInCart.product_id;
    });
    var hasMultipleQuantity = giftInCart.quantity > 1;
    return doesNotQualify || hasMultipleQuantity;
  });

  if (invalidGiftsInCart.length) {
    var updates = invalidGiftsInCart.reduce(function (_updates, _item) {
      _updates[_item.key] = 0;
      return _updates;
    }, {});
    return updateLineItems(updates);
  }
  /**
   * Add any gifts that qualify, aren't currently in the cart and haven't been
   * manually removed this session
   */


  var giftsToAdd = qualifyingGifts.filter(function (qualifyingGift) {
    var isNotInCart = giftsInCart.every(function (giftInCart) {
      return qualifyingGift.product.id !== giftInCart.product_id;
    });
    var hasNotBeenManuallyRemoved = !manuallyRemovedGifts.includes(qualifyingGift.product.id);
    return isNotInCart && hasNotBeenManuallyRemoved;
  });

  if (giftsToAdd.length) {
    var items = giftsToAdd.map(function (_ref) {
      var product = _ref.product;
      return {
        id: product.variants[0].id,
        quantity: 1,
        properties: {
          _gwp: true
        }
      };
    });
    return addLineItems(items);
  }
};

/***/ }),

/***/ 365:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _Cart__WEBPACK_IMPORTED_MODULE_0__.default)
/* harmony export */ });
/* harmony import */ var _Cart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(366);


/***/ }),

/***/ 386:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(223);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(170);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(115);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(345);
/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(135);












function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var RewardsBalance = function RewardsBalance() {
  var _window$theme, _window$theme2, _window$theme2$reward;

  // eslint-disable-next-line no-unused-vars
  var _useBalance = useBalance(),
      _useBalance2 = _slicedToArray(_useBalance, 2),
      balance = _useBalance2[0],
      error = _useBalance2[1];

  return ((_window$theme = window.theme) === null || _window$theme === void 0 ? void 0 : _window$theme.customer) && ((_window$theme2 = window.theme) === null || _window$theme2 === void 0 ? void 0 : (_window$theme2$reward = _window$theme2.rewards) === null || _window$theme2$reward === void 0 ? void 0 : _window$theme2$reward.enabled) && balance && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("div", {
    className: "cart__rewards-balance"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("p", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("span", null, window.theme.rewards.yourRewardsBalance), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("span", null, (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_12__.formatMoney)(balance, window.theme.moneyFormatWithoutCurrency))));
};

var useBalance = function useBalance() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      balance = _useState2[0],
      setBalance = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function () {
    var _window$theme3, _window$theme3$reward;

    if (!((_window$theme3 = window.theme) !== null && _window$theme3 !== void 0 && (_window$theme3$reward = _window$theme3.rewards) !== null && _window$theme3$reward !== void 0 && _window$theme3$reward.enabled)) return;
    document.addEventListener('rewardsInfoFetched', function () {
      setBalance(window.rewardsApi.data.balance);
    });
    document.addEventListener('rewardsInfoFetchError', function () {
      setError(window.theme.rewards.error);
    });
  }, []);
  return [balance, error];
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RewardsBalance);

/***/ }),

/***/ 388:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(345);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(350);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_flickity_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(389);
/* harmony import */ var react_flickity_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_flickity_component__WEBPACK_IMPORTED_MODULE_2__);



var flickityOptions = {
  draggable: '>1',
  wrapAround: true,
  groupCells: false,
  pageDots: true,
  prevNextButtons: false,
  autoPlay: true,
  cellAlign: 'center',
  watchCSS: true
};

var TrustIndicatorsInnerContent = function TrustIndicatorsInnerContent() {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement(react__WEBPACK_IMPORTED_MODULE_0__.default.Fragment, null, window.theme.indicators.text1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement(react__WEBPACK_IMPORTED_MODULE_0__.default.Fragment, null, window.theme.indicators.link1 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("a", {
    href: window.theme.indicators.link1,
    className: "trust-indicator"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("span", {
    className: "trust-indicator__icon"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("svg", {
    "aria-label": window.theme.indicators.text1,
    className: "icon icon-".concat(window.theme.indicators.icon1),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("use", {
    xlinkHref: "#iconIndicator1"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("span", {
    className: "trust-indicator__text"
  }, window.theme.indicators.text1)) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("span", {
    className: "trust-indicator"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("span", {
    className: "trust-indicator__icon"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("svg", {
    "aria-label": window.theme.indicators.text1,
    className: "icon icon-".concat(window.theme.indicators.icon1),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("use", {
    xlinkHref: "#iconIndicator1"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("span", {
    className: "trust-indicator__text"
  }, window.theme.indicators.text1))), window.theme.indicators.text2 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement(react__WEBPACK_IMPORTED_MODULE_0__.default.Fragment, null, window.theme.indicators.link2 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("a", {
    href: window.theme.indicators.link2,
    className: "trust-indicator"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("span", {
    className: "trust-indicator__icon"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("svg", {
    "aria-label": window.theme.indicators.text2,
    className: "icon icon-".concat(window.theme.indicators.icon2),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("use", {
    xlinkHref: "#iconIndicator2"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("span", {
    className: "trust-indicator__text"
  }, window.theme.indicators.text2)) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("span", {
    className: "trust-indicator"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("span", {
    className: "trust-indicator__icon"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("svg", {
    "aria-label": window.theme.indicators.text2,
    className: "icon icon-".concat(window.theme.indicators.icon2),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("use", {
    xlinkHref: "#iconIndicator2"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("span", {
    className: "trust-indicator__text"
  }, window.theme.indicators.text2))), window.theme.indicators.text3 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement(react__WEBPACK_IMPORTED_MODULE_0__.default.Fragment, null, window.theme.indicators.link3 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("a", {
    href: window.theme.indicators.link3,
    className: "trust-indicator"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("span", {
    className: "trust-indicator__icon"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("svg", {
    "aria-label": window.theme.indicators.text3,
    className: "icon icon-".concat(window.theme.indicators.icon3),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("use", {
    xlinkHref: "#iconIndicator3"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("span", {
    className: "trust-indicator__text"
  }, window.theme.indicators.text3)) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("span", {
    className: "trust-indicator"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("span", {
    className: "trust-indicator__icon"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("svg", {
    "aria-label": window.theme.indicators.text3,
    className: "icon icon-".concat(window.theme.indicators.icon3),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("use", {
    xlinkHref: "#iconIndicator3"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("span", {
    className: "trust-indicator__text"
  }, window.theme.indicators.text3))));
};

var TrustIndicators = function TrustIndicators(_ref) {
  var layout = _ref.layout,
      isCartPage = _ref.isCartPage;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement(react__WEBPACK_IMPORTED_MODULE_0__.default.Fragment, null, layout === 'grid' && isCartPage ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement("div", {
    className: "trust-indicators"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement(TrustIndicatorsInnerContent, null)) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement((react_flickity_component__WEBPACK_IMPORTED_MODULE_2___default()), {
    className: isCartPage ? 'trust-indicators--slider  trust-indicators--slider-alt' : 'trust-indicators--slider',
    elementType: "div",
    options: flickityOptions,
    disableImagesLoaded: false,
    reloadOnUpdate: true,
    "static": true
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.default.createElement(TrustIndicatorsInnerContent, null)));
};

TrustIndicators.propTypes = {
  layout: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  isCartPage: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TrustIndicators);

/***/ }),

/***/ 387:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _TrustIndicators__WEBPACK_IMPORTED_MODULE_0__.default)
/* harmony export */ });
/* harmony import */ var _TrustIndicators__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(388);


/***/ }),

/***/ 347:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Modal": () => (/* reexport safe */ _modal__WEBPACK_IMPORTED_MODULE_0__.default),
/* harmony export */   "Cart": () => (/* reexport safe */ _cart__WEBPACK_IMPORTED_MODULE_1__.default),
/* harmony export */   "ShippingTimes": () => (/* reexport safe */ _shipping_times__WEBPACK_IMPORTED_MODULE_2__.default)
/* harmony export */ });
/* harmony import */ var _modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(348);
/* harmony import */ var _cart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(365);
/* harmony import */ var _shipping_times__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(396);




/***/ }),

/***/ 349:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(223);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(170);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(115);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(345);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(350);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var focus_trap_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(359);
/* harmony import */ var focus_trap_react__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(focus_trap_react__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(363);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(364);












function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








var Modal = function Modal(_ref) {
  var _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      triggerLabel = _ref.triggerLabel,
      _ref$closeLabel = _ref.closeLabel,
      closeLabel = _ref$closeLabel === void 0 ? 'Close Modal' : _ref$closeLabel,
      className = _ref.className,
      children = _ref.children,
      _ref$container = _ref.container,
      container = _ref$container === void 0 ? document.body : _ref$container,
      toggleClass = _ref.toggleClass,
      toggleEvent = _ref.toggleEvent;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(isOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var toggleScrollLock = function toggleScrollLock() {
    var _document$querySelect;

    return (_document$querySelect = document.querySelector('html')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.toggle('scroll-lock');
  };

  var toggleOpenClass = function toggleOpenClass() {
    var _document$querySelect2;

    var toggleClassString = toggleClass ? "".concat(toggleClass, "-") : '';
    (_document$querySelect2 = document.querySelector('html')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.classList.toggle("modal-".concat(toggleClassString, "open"));
  };

  var closeModal = function closeModal() {
    setOpen(false);
    toggleScrollLock();
    toggleOpenClass();
  };

  var toggleModal = function toggleModal() {
    setOpen(!open);
    toggleScrollLock();
    toggleOpenClass();
  };

  var handleEscKey = function handleEscKey(event) {
    return event.keyCode === 27 && closeModal();
  };

  var handleOutsideClick = function handleOutsideClick(event) {
    return event.target === event.currentTarget && closeModal();
  };
  /**
   * The below useEffect() allows the modal to be toggled with a custom event; toggleEvent.
   */


  (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function () {
    if (!toggleEvent) return;
    document.addEventListener(toggleEvent, toggleModal);
    return function () {
      return document.removeEventListener(toggleEvent, toggleModal);
    };
  }, [open]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement(react__WEBPACK_IMPORTED_MODULE_11__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("button", {
    onClick: toggleModal,
    className: classnames__WEBPACK_IMPORTED_MODULE_14___default()('modal__trigger', className),
    type: "button"
  }, triggerLabel), !open && null, open && /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_11__.createPortal)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement((focus_trap_react__WEBPACK_IMPORTED_MODULE_13___default()), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_14___default()('modal', size === 'sm' && 'modal--sm', size === 'md' && 'modal--md'),
    role: "dialog",
    tabIndex: -1,
    "aria-modal": "true",
    onClick: handleOutsideClick,
    onKeyDown: handleEscKey
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("div", {
    className: "modal__dialog"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("button", {
    className: "modal__close-button",
    onClick: closeModal,
    "aria-label": closeLabel,
    type: "button"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_15__
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("div", {
    className: "modal__body"
  }, children))))), container));
};

Modal.propTypes = {
  isOpen: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().bool),
  size: prop_types__WEBPACK_IMPORTED_MODULE_12___default().oneOf(['sm', 'md', 'full-screen']),
  triggerLabel: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().node),
  closeLabel: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
  children: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().node),
  container: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().node),
  toggleEvent: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
  toggleClass: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Modal);

/***/ }),

/***/ 348:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _Modal__WEBPACK_IMPORTED_MODULE_0__.default)
/* harmony export */ });
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(349);


/***/ }),

/***/ 397:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_from_entries_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98);
/* harmony import */ var core_js_modules_es_object_from_entries_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_from_entries_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(104);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(134);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(149);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(110);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(223);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(170);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(115);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(91);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(67);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(345);
/* harmony import */ var papaparse__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(398);
/* harmony import */ var papaparse__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(papaparse__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(363);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_18__);

















function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var POSTCODE_INPUT_FIELDNAME = 'shipping-postcode';
var POSTCODE_REGEX = window.theme.shippingTimes.shippingTimesRegion === 'AU' ? /^(?:(?:[2-8]\d|9[0-7]|0?[28]|0?9(?=09))(?:\d{2}))$/ : /^\d{5}(?:-\d{4})?$/;
var CSV = window.theme.shippingTimes.shippingTimesCsv;
var DEFAULT_SHIPPING_DAYS = window.theme.strings.product.shippingTimesDefaultDays;
var MESSAGES = {
  successTemplate: window.theme.strings.product.shippingTimesMessageTemplate,
  error: window.theme.strings.product.shippingTimesErrorMessage,
  reset: window.theme.strings.product.shippingTimesReset
};

var ShippingTimes = function ShippingTimes() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      successMessage = _useState2[0],
      setSuccessMessage = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      formIsInvalid = _useState4[0],
      setFormIsInvalid = _useState4[1];

  if (!CSV) return null;
  var handleFormSubmit = makeHandleFormSubmit({
    setSuccessMessage: setSuccessMessage,
    setFormIsInvalid: setFormIsInvalid
  });

  var resetForm = function resetForm() {
    return setSuccessMessage(null);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16__.default.createElement("div", {
    className: "shipping-times"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16__.default.createElement("h5", {
    className: "h6 text-center"
  }, window.theme.strings.product.shippingTimesTitle), successMessage ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16__.default.createElement(react__WEBPACK_IMPORTED_MODULE_16__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16__.default.createElement("p", null, successMessage), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16__.default.createElement("button", {
    type: "button",
    className: "btn__text",
    onClick: resetForm
  }, MESSAGES.reset)) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16__.default.createElement("form", {
    onSubmit: handleFormSubmit
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16__.default.createElement("div", {
    className: "form__group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16__.default.createElement("label", {
    htmlFor: POSTCODE_INPUT_FIELDNAME,
    "class": "visually-hidden"
  }, window.theme.strings.product.shippingTimesPlaceholder), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16__.default.createElement("input", {
    type: "number",
    name: POSTCODE_INPUT_FIELDNAME,
    id: POSTCODE_INPUT_FIELDNAME,
    className: classnames__WEBPACK_IMPORTED_MODULE_18___default()('subscribe-form__input', {
      'input-error': formIsInvalid
    }),
    placeholder: window.theme.strings.product.shippingTimesPlaceholder,
    "aria-label": window.theme.strings.product.shippingTimesPlaceholder,
    autoComplete: false,
    onChange: function onChange() {
      return setFormIsInvalid(false);
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16__.default.createElement("button", {
    type: "submit",
    disabled: formIsInvalid,
    className: "btn subscribe-form__button"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16__.default.createElement("span", null, window.theme.strings.product.shippingTimesButton)), formIsInvalid && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16__.default.createElement("p", {
    className: "form__field-error"
  }, MESSAGES.error))));
};
/**
 * @function makeHandleFormSubmit - handleFormSubmit factory for shipping times form.
 *
 * @param {function} setSuccessMessage - react state setter
 *
 * @returns {function} formHandler
 */


var makeHandleFormSubmit = function makeHandleFormSubmit(_ref) {
  var setSuccessMessage = _ref.setSuccessMessage,
      setFormIsInvalid = _ref.setFormIsInvalid;
  return function (e) {
    e.preventDefault();

    var _Object$fromEntries = Object.fromEntries(new FormData(e.target)),
        postcode = _Object$fromEntries[POSTCODE_INPUT_FIELDNAME];

    if (postcode.match(POSTCODE_REGEX) === null) {
      setFormIsInvalid(true);
      return;
    }

    getShippingTime(postcode, setSuccessMessage);
  };
};
/**
 * @function getShippingTime - uses papaparse to get the file at the CSV url and parse it.
 *
 * @param {string}   postcode             - postcode for which to get shipping times
 * @param {function} setSuccessMessage  - react state setter
 *
 * @returns void
 */


var getShippingTime = function getShippingTime(postcode, setSuccessMessage) {
  papaparse__WEBPACK_IMPORTED_MODULE_17___default().parse(CSV, {
    download: true,
    header: true,
    complete: function complete(results) {
      var allPostcodes = results.data;
      var matchingPostcode = allPostcodes.find(function (code) {
        return code.postcode === postcode;
      });
      setSuccessMessage(makeSuccessMessage(matchingPostcode ? matchingPostcode.days : DEFAULT_SHIPPING_DAYS));
    }
  });
};
/**
 * @function makeSuccessMessage
 *
 * @param {string|number} days - string or number representing the number of
 * days shipping is expected to take. This value comes directy from the
 * spreadsheet so we cannot gaurantee it's type.
 *
 * @returns {string} - success message string
 */


var makeSuccessMessage = function makeSuccessMessage(days) {
  var dayWord = days === 1 || days === '1' ? 'day' : 'days';
  return MESSAGES.successTemplate.replace('{daysNumber}', days).replace('{daysWord}', dayWord);
};

ShippingTimes.propTypes = {};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ShippingTimes);

/***/ }),

/***/ 396:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _ShippingTimes__WEBPACK_IMPORTED_MODULE_0__.default)
/* harmony export */ });
/* harmony import */ var _ShippingTimes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(397);


/***/ }),

/***/ 344:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(100);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(345);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(347);





var App = function App() {
  var _document$querySelect;

  if (!window.theme.ecommerce) return;
  var rootUrl = window.theme.locale && !window.theme.locale.primary ? window.theme.locale.rootUrl : '';
  var freeShippingBarSettings = {
    enabled: window.theme.freeShippingBar && window.theme.freeShippingBar.enabled,
    remainingTemplate: window.theme.strings.freeShippingBar.remaining,
    reachedTemplate: window.theme.strings.freeShippingBar.reached,
    serviceOne: window.theme.freeShippingBar.serviceOne,
    thresholdOne: Number(window.theme.freeShippingBar.thresholdOne) * 100
  };
  var giftWithPurchaseDetails = JSON.parse(((_document$querySelect = document.querySelector('[data-gift-with-purchase]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.innerText) || '{"gifts": [],"giftsInCart": []}');
  react__WEBPACK_IMPORTED_MODULE_1__.default.render( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.default.createElement(_components__WEBPACK_IMPORTED_MODULE_2__.Cart, {
    rootUrl: rootUrl,
    freeShippingBarSettings: freeShippingBarSettings,
    giftWithPurchaseDetails: giftWithPurchaseDetails,
    isCartPage: false
  }), document.querySelector('#react-cart'));
  var cartPageWrapper = document.querySelector('.cart-page-app');

  if (cartPageWrapper && window.location.pathname === '/cart' || cartPageWrapper && window.location.pathname === '/cart/') {
    react__WEBPACK_IMPORTED_MODULE_1__.default.render( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.default.createElement(_components__WEBPACK_IMPORTED_MODULE_2__.Cart, {
      rootUrl: rootUrl,
      freeShippingBarSettings: freeShippingBarSettings,
      giftWithPurchaseDetails: giftWithPurchaseDetails,
      isCartPage: true
    }), document.querySelector('#react-cart-page'));
  }

  var shippingTimesWrapper = document.querySelector('.shipping-times__wrapper');

  if (shippingTimesWrapper) {
    react__WEBPACK_IMPORTED_MODULE_1__.default.render( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.default.createElement(_components__WEBPACK_IMPORTED_MODULE_2__.ShippingTimes, null), document.querySelector('#react-shipping-times'));
  }
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (App);

/***/ }),

/***/ 379:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(118);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3__);





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var changeLineItem = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item, rootUrl, setEditItem, setEditProduct) {
    var url, options, response, product;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = "".concat(rootUrl, "/products/").concat(item.handle, ".js");
            options = {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            };
            _context.prev = 2;
            _context.next = 5;
            return fetch(url, options);

          case 5:
            response = _context.sent;

            if (!(response.ok === false)) {
              _context.next = 8;
              break;
            }

            throw new Error('product response was not OK');

          case 8:
            _context.next = 10;
            return response.json();

          case 10:
            product = _context.sent;
            setEditProduct(product);
            setEditItem(item);
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](2);
            window.console.error(_context.t0);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 15]]);
  }));

  return function changeLineItem(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (changeLineItem);

/***/ }),

/***/ 395:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(118);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(143);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_3__);





function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var removeLineItem = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(key) {
    var data, url, options, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Add loading class
            document.body.classList.add('cart-loading');
            data = {
              updates: _defineProperty({}, key, 0)
            };
            url = "".concat(window.theme.locale && !window.theme.locale.primary ? window.theme.locale.rootUrl : '', "/cart/update.js");
            options = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            };
            _context.prev = 4;
            _context.next = 7;
            return fetch(url, options);

          case 7:
            response = _context.sent;

            if (!(response.ok === false)) {
              _context.next = 10;
              break;
            }

            throw new Error('cart/update response was not OK');

          case 10:
            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](4);
            window.console.error(_context.t0);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 12]]);
  }));

  return function removeLineItem(_x) {
    return _ref.apply(this, arguments);
  };
}();

var updateVariant = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(item, selectedVariant, setVariants, setSelectedVariant, addLineItems) {
    var newLineItem;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            newLineItem = {
              id: selectedVariant.id,
              quantity: item.quantity
            }; // Only add properties if they exist

            if ('properties' in item) {
              newLineItem.properties = item.properties;
            }

            _context2.next = 4;
            return removeLineItem(item.key);

          case 4:
            _context2.next = 6;
            return addLineItems(newLineItem);

          case 6:
            setVariants([]);
            setSelectedVariant(null);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function updateVariant(_x2, _x3, _x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (updateVariant);

/***/ }),

/***/ 380:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "imageUrl": () => (/* binding */ imageUrl)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(170);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(284);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_4__);






/**
 * Replicates Shopify's `image_url` filter in js.
 * - At least one of `width` or `height` must be provided.
 * - If no `crop` is provided, it will default to `center`.
 * - `format` and `pad_color` are unsupported.
 *
 * @param {string} url - Shopify image url.
 * @param {number} [width] - Image width integer (max 5760).
 * @param {number} [height] - Image height integer (max 5760).
 * @param {('top'|'bottom'|'center'|'left'|'right')} [crop="center"] - Image crop, defaults to `center`.
 * @returns {string}
 */
var imageUrl = function imageUrl(url, width, height, crop) {
  if (!url || !(width || height)) return null;
  if (width && typeof width !== 'number') return null;
  if (height && typeof height !== 'number') return null;
  if (crop && typeof crop !== 'string') return null;

  try {
    var urlObj = new URL(url);
    var params = urlObj.searchParams;
    var currentWidth = params.get('width');
    var currentHeight = params.get('height');
    var currentCrop = params.get('crop');
    if (!height && currentHeight) params["delete"]('height');
    if (!width && currentWidth) params["delete"]('width');
    if (!crop && currentCrop) params["delete"]('crop');
    if (width) params.set('width', width);
    if (height) params.set('height', height);
    if (crop) params.set('crop', crop);
    return urlObj.href;
  } catch (error) {
    return null;
  }
};

/***/ }),

/***/ 370:
/***/ ((module) => {

"use strict";
module.exports = "<svg aria-label=\"Afterpay logo\" class=\"icon-payment icon-afterpay\" xmlns=\"http://www.w3.org/2000/svg\" width=\"78\" height=\"24\" viewBox=\"0 0 78 24\"><path d=\"M68.789,8.445l1.963,1.129c.254,.181,.457,.423,.593,.704,.139,.22,.233,.465,.277,.721,.044,.256,.036,.519-.023,.772-.059,.253-.167,.492-.319,.703-.152,.211-.344,.39-.565,.526l-1.963,1.13-2,1.148c-.301,.172-.643,.261-.99,.26-.347-.001-.687-.094-.987-.268-.3-.174-.549-.424-.722-.725-.173-.301-.264-.642-.264-.989v-.296c.019-.073,.019-.149,0-.222-.026-.044-.062-.082-.103-.113-.041-.03-.089-.052-.138-.064-.05-.012-.102-.014-.153-.006-.051,.008-.099,.026-.143,.053l-1.852,1.055-1.852,1.037-.13,.13c-.038,.096-.038,.203,0,.299,.038,.096,.111,.175,.204,.219l1.852,1.037,1.852,1.055c.073,.017,.149,.017,.222,0,.051-.002,.101-.015,.148-.037,.046-.022,.088-.052,.122-.09,.034-.038,.061-.082,.078-.13,.017-.048,.025-.099,.022-.15v-.593c-.016-.067-.016-.137,0-.204,.023-.045,.055-.084,.094-.117,.039-.032,.084-.056,.133-.07,.049-.014,.099-.018,.149-.011s.098,.023,.142,.049l.926,.537c.057,.039,.104,.092,.136,.153,.032,.061,.049,.129,.049,.199v.241c0,.347-.091,.688-.264,.989-.173,.301-.422,.551-.722,.725-.3,.174-.64,.267-.987,.268-.347,.001-.688-.088-.99-.26l-2-1.13-1.963-1.129c-.313-.17-.57-.428-.741-.741-.256-.458-.321-.997-.183-1.503s.47-.937,.923-1.2l1.963-1.129,2-1.148c.301-.172,.643-.261,.99-.26,.347,.002,.687,.094,.987,.268,.3,.174,.549,.424,.722,.725,.173,.301,.264,.642,.264,.989v.296c-.019,.073-.019,.149,0,.222,.027,.044,.062,.082,.103,.113,.041,.03,.088,.052,.138,.064,.05,.012,.102,.014,.153,.006,.051-.008,.099-.026,.143-.053l1.852-1.055,1.852-1.037,.13-.13c.055-.091,.073-.2,.049-.304-.024-.104-.088-.194-.178-.251l-1.852-1.037-1.852-1.055h-.222c-.051,.002-.101,.015-.147,.037-.046,.022-.088,.052-.122,.09-.034,.038-.061,.082-.078,.13s-.025,.099-.022,.15v.593c.016,.061,.016,.125,0,.185-.023,.045-.055,.084-.094,.116-.039,.032-.084,.056-.133,.069-.049,.014-.1,.018-.15,.011-.05-.007-.098-.023-.142-.049l-.926-.518c-.057-.039-.104-.092-.136-.153-.032-.061-.049-.13-.049-.199v-.241c0-.347,.091-.688,.264-.989,.173-.301,.422-.551,.722-.725,.3-.174,.64-.267,.987-.268,.347-.001,.688,.088,.99,.26l1.963,1.185Z\" fill=\"currentColor\"/><path d=\"M53.218,19.425l4.61-9.517h-1.889l-1.852,3.981-1.74-3.981h-1.963l2.703,5.962-1.722,3.555h1.852Z\" fill=\"currentColor\"/><path d=\"M11.742,16.666v-.889c-.261,.316-.59,.569-.961,.742-.372,.173-.777,.261-1.187,.258-.435-.01-.864-.105-1.263-.28-.398-.175-.758-.428-1.059-.742-.301-.315-.537-.686-.694-1.091-.158-.406-.234-.839-.224-1.274v-.111c-.017-.443,.053-.884,.206-1.3,.154-.415,.387-.797,.688-1.122,.301-.325,.663-.588,1.066-.772,.402-.185,.837-.289,1.28-.306,.403-.003,.801,.084,1.166,.254,.365,.17,.688,.418,.945,.728v-.852h1.648v6.758h-1.611Zm0-3.388c-.018-.362-.142-.71-.356-1.002-.214-.292-.509-.515-.849-.641-.34-.126-.709-.15-1.061-.068-.353,.082-.674,.265-.924,.527-.25,.262-.417,.592-.481,.948-.064,.357-.023,.724,.12,1.057,.142,.333,.379,.617,.682,.817,.302,.2,.656,.306,1.018,.307,.491,0,.962-.195,1.309-.542,.347-.347,.542-.818,.542-1.309v-.093Z\" fill=\"currentColor\" fill-rule=\"evenodd\"/><path d=\"M20.759,14.352c0,.556,.148,.778,.741,.778h.333v1.592h-.926c-1.333,0-1.852-.593-1.852-1.981v-3.314h-2.222v5.295h-1.685v-5.295h-.944v-1.537h.944v-.907c0-1.389,.667-1.852,2.074-1.852h.796v1.315h-.37c-.593,0-.815,.222-.815,.778v.685h2.222v-1.648h1.703v1.703h1.055v1.463h-1.055v2.925Z\" fill=\"currentColor\"/><path d=\"M24.24,13.722c.029,.437,.226,.846,.551,1.14,.325,.294,.751,.45,1.189,.434,.318,.004,.631-.074,.91-.227s.514-.374,.682-.644h1.74c-.215,.714-.665,1.334-1.276,1.761-.611,.427-1.349,.635-2.093,.59-.881,.061-1.751-.23-2.418-.81-.667-.58-1.076-1.401-1.137-2.282v-.407c0-.928,.369-1.818,1.025-2.474,.656-.656,1.546-1.025,2.475-1.025s1.818,.369,2.475,1.025c.656,.656,1.025,1.546,1.025,2.474,.018,.141,.018,.285,0,.426l-5.147,.019Zm3.37-1.055c-.055-.401-.259-.766-.571-1.023-.312-.257-.71-.388-1.114-.365-.405-.019-.803,.113-1.117,.369-.314,.256-.523,.619-.587,1.02h3.388Z\" fill=\"currentColor\" fill-rule=\"evenodd\"/><path d=\"M34.924,9.908v9.517h1.759v-3.555c.256,.292,.572,.524,.927,.681s.74,.234,1.128,.227c.443-.017,.878-.12,1.28-.305,.403-.185,.765-.448,1.065-.773,.301-.325,.535-.706,.688-1.122,.153-.415,.224-.857,.206-1.3v-.13c.007-.435-.071-.868-.231-1.273-.16-.405-.398-.774-.7-1.087-.303-.313-.664-.563-1.063-.736-.399-.173-.829-.266-1.264-.273-.41-.003-.815,.085-1.187,.258-.372,.173-.7,.426-.961,.742v-.87h-1.648Zm4.785,2.083c.351,.338,.554,.8,.566,1.287v.093c-.012,.487-.216,.949-.566,1.287s-.821,.524-1.308,.518c-.487-.006-.952-.204-1.294-.55-.342-.347-.534-.814-.534-1.301s.192-.954,.534-1.301c.342-.347,.807-.544,1.294-.55,.487-.006,.957,.18,1.308,.518Z\" fill=\"currentColor\" fill-rule=\"evenodd\"/><path d=\"M47.978,16.666v-.889c-.257,.316-.582,.571-.95,.744-.369,.173-.772,.261-1.179,.256-.435-.007-.865-.1-1.264-.273-.399-.173-.761-.424-1.063-.736-.303-.313-.541-.682-.701-1.087-.16-.405-.238-.837-.231-1.273v-.13c-.017-.443,.053-.884,.206-1.3,.153-.416,.387-.797,.688-1.122,.301-.325,.663-.588,1.066-.772,.403-.185,.838-.289,1.28-.306,.4-.003,.795,.084,1.157,.254,.362,.17,.681,.418,.935,.727v-.852h1.666v6.758h-1.611Zm0-3.388c-.018-.358-.14-.702-.35-.992s-.5-.513-.834-.641c-.334-.128-.699-.157-1.049-.083-.35,.074-.672,.249-.925,.502-.253,.253-.427,.575-.502,.925-.074,.35-.046,.715,.083,1.049,.128,.334,.351,.624,.641,.834,.29,.21,.635,.332,.992,.35h.093c.491,0,.962-.195,1.309-.542,.347-.347,.542-.818,.542-1.309v-.093Z\" fill=\"currentColor\" fill-rule=\"evenodd\"/><path d=\"M32.55,9.983c-.257,.14-.472,.343-.626,.591v-.667h-1.666v6.758h1.722v-3.999c-.039-.295,.034-.595,.206-.838,.172-.244,.429-.414,.72-.476,.424-.017,.843,.092,1.203,.315v-1.74c-.226-.104-.473-.155-.722-.148-.292-.005-.58,.065-.837,.205Z\" fill=\"currentColor\"/></svg>\n";

/***/ }),

/***/ 369:
/***/ ((module) => {

"use strict";
module.exports = "<svg aria-label=\"Left arrow icon\" class=\"icon icon-arrow-left\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"m2 12 6-6m-6 6 6 6m-6-6h20\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"square\" vector-effect=\"non-scaling-stroke\"/>\n</svg>\n";

/***/ }),

/***/ 364:
/***/ ((module) => {

"use strict";
module.exports = "<svg aria-label=\"Cross icon\" class=\"icon icon-cross\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M18 6 6 18M6 6l12 12\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"square\" vector-effect=\"non-scaling-stroke\"/>\n</svg>";

/***/ }),

/***/ 383:
/***/ ((module) => {

"use strict";
module.exports = "<svg aria-label=\"Edit icon\" class=\"icon icon-edit\" width=\"14\" height=\"14\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\"><path d=\"M3.09,9.11l6-6a.59.59,0,0,1,.83,0l1,1a.57.57,0,0,1,0,.82l-6,6a.58.58,0,0,1-.41.17H2.92V9.52A.58.58,0,0,1,3.09,9.11Z\" fill=\"none\" stroke=\"currentColor\" vector-effect=\"non-scaling-stroke\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M8,4.18,9.82,6\" fill=\"none\" stroke=\"currentColor\" vector-effect=\"non-scaling-stroke\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>";

/***/ }),

/***/ 381:
/***/ ((module) => {

"use strict";
module.exports = "<svg aria-label=\"Minus icon\" class=\"icon icon-minus-sm\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 10h1.25\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"square\" vector-effect=\"non-scaling-stroke\"/><path d=\"M5 10h10\" stroke=\"currentColor\" stroke-width=\"1.2\" vector-effect=\"non-scaling-stroke\"/></svg>";

/***/ }),

/***/ 382:
/***/ ((module) => {

"use strict";
module.exports = "<svg aria-label=\"Plus icon\" class=\"icon icon-plus-sm\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 5v10M5 10h10\" stroke=\"currentColor\" stroke-width=\"1.2\" vector-effect=\"non-scaling-stroke\"/></svg>";

/***/ })

}]);